import { mergeStyles, Stack } from "@fluentui/react";
import { useEffect, useState } from "react";
import MediaQuery from "react-responsive";
import { containerCentered, containerStylesLG, containerStylesMD, containerStylesSM, containerStylesXL, containerStylesXXL, containerStylesXXXL } from "./ContainerStyles";

export interface IContainerFluidProps {
    backgroundImage?: string;
    centered?: boolean;
}

export const ContainerFluid: React.FC<IContainerFluidProps> = (props) => {
    const [breakpointsm] = useState<Breakpoint>(GetBreakpoint(BreakpointType.sm));
    const [breakpointmd] = useState<Breakpoint>(GetBreakpoint(BreakpointType.md));
    const [breakpointlg] = useState<Breakpoint>(GetBreakpoint(BreakpointType.lg));
    const [breakpointxl] = useState<Breakpoint>(GetBreakpoint(BreakpointType.xl));
    const [breakpointxxl] = useState<Breakpoint>(GetBreakpoint(BreakpointType.xxl));
    const [breakpointxxxl] = useState<Breakpoint>(GetBreakpoint(BreakpointType.xxxl));

    const globalBodyStyle = mergeStyles({
        margin: 0,
        padding: 0,
        width: '100dvw',
        height: '100dvh',
        overflow: 'auto',
        backgroundImage: props.backgroundImage && `url(${props.backgroundImage})`,
        backgroundSize: props.backgroundImage && 'cover',
        backgroundRepeat: props.backgroundImage && 'no-repeat'
    });

    useEffect(() => {
        document.body.classList.add(globalBodyStyle);
        return () => {
            document.body.classList.remove(globalBodyStyle);
        };
    }, []);

    return (
        <>
            <MediaQuery minWidth={breakpointsm.minWidth} maxWidth={breakpointsm.maxWidth}>
                <Stack className={mergeStyles([containerStylesSM, props.centered ? containerCentered : ''])}>
                    {props.children}
                </Stack>
            </MediaQuery>
            <MediaQuery minWidth={breakpointmd.minWidth} maxWidth={breakpointmd.maxWidth}>
                <Stack className={mergeStyles([containerStylesMD, props.centered ? containerCentered : ''])}>
                    {props.children}
                </Stack>
            </MediaQuery>
            <MediaQuery minWidth={breakpointlg.minWidth} maxWidth={breakpointlg.maxWidth}>
                <Stack className={mergeStyles([containerStylesLG, props.centered ? containerCentered : ''])}>
                    {props.children}
                </Stack>
            </MediaQuery>
            <MediaQuery minWidth={breakpointxl.minWidth} maxWidth={breakpointxl.maxWidth}>
                <Stack className={mergeStyles([containerStylesXL, props.centered ? containerCentered : ''])}>
                    {props.children}
                </Stack>
            </MediaQuery>
            <MediaQuery minWidth={breakpointxxl.minWidth} maxWidth={breakpointxxl.maxWidth}>
                <Stack className={mergeStyles([containerStylesXXL, props.centered ? containerCentered : ''])}>
                    {props.children}
                </Stack>
            </MediaQuery>
            <MediaQuery minWidth={breakpointxxxl.minWidth}>
                <Stack className={mergeStyles([containerStylesXXXL, props.centered ? containerCentered : ''])}>
                    {props.children}
                </Stack>
            </MediaQuery>
        </>
    )
}

export const GetBreakpoint = (type: BreakpointType): Breakpoint => { //px
    let breakpoint = new Breakpoint();

    switch (type) {
        case BreakpointType.sm:
            breakpoint.minWidth = 320;
            breakpoint.maxWidth = 479;
            break;
        case BreakpointType.md:
            breakpoint.minWidth = 480;
            breakpoint.maxWidth = 639;
            break;
        case BreakpointType.lg:
            breakpoint.minWidth = 640;
            breakpoint.maxWidth = 1023;
            break;
        case BreakpointType.xl:
            breakpoint.minWidth = 1024;
            breakpoint.maxWidth = 1365;
            break;
        case BreakpointType.xxl:
            breakpoint.minWidth = 1366;
            breakpoint.maxWidth = 1919;
            break;
        case BreakpointType.xxxl:
            breakpoint.minWidth = 1920;
            breakpoint.maxWidth = 99999;
            break;
    }

    return breakpoint;
}

export enum BreakpointType {
    sm, //320px - 479px
    md, //480px - 639px
    lg, //640px - 1023px
    xl, //1024px - 1365px
    xxl, //1366px - 1919px
    xxxl //1920px - UP
}

export enum BreakpointCalculationSign {
    greaterThan, //Greater Than
    lessThan, //Less Than
    equalTo, //Equal
    greaterThanOrEqual, //Greater Than or Equal
    lessThanOrEqual, //Less Than or Equal
    between //Between
}

export class Breakpoint {
    public minWidth: number = 0;
    public maxWidth: number = 0;
}